import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="glass-effect text-gray-300 pt-16 pb-8 mt-16 relative">
      <div className="absolute inset-0 bg-gradient-to-t from-dark-400 to-transparent -z-10"></div>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="https://media.licdn.com/dms/image/v2/D4E0BAQHGMRq0cxudrw/company-logo_100_100/company-logo_100_100/0/1727091211440?e=1749081600&v=beta&t=28OoNw5xVIa6NRPMb9WDqA9psxpJaIaa9NoAETHhZ5Q" 
                alt="AMOGOTech Logo" 
                className="w-10 h-10 mr-2 rounded-full border-2 border-white shadow-lg"
              />
              <span className="text-xl font-bold text-white">AMOGO<span className="text-primary-500">Tech</span></span>
            </Link>
            <p className="text-gray-400 mb-6">
              Solutions technologiques innovantes pour répondre aux défis technologiques.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.linkedin.com/search/results/all/?keywords=AMOGOTech&origin=HISTORY&sid=bvj" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Liens rapides</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-500 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-primary-500 transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-primary-500 transition-colors">
                  Produits
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-500 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Nos produits</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/products#route-senegal" className="text-gray-400 hover:text-primary-500 transition-colors">
                  Code de la Route Senegal
                </Link>
              </li>
              {/* <li>
                <Link to="/products#multichange" className="text-gray-400 hover:text-primary-500 transition-colors">
                  Multichange
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={20} className="text-primary-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-400">Ouest Foire prés Case des tout petits, Dakar</span>
              </li>
              <li className="flex items-center">
                <Phone size={20} className="text-primary-500 mr-3 flex-shrink-0" />
                <span className="text-gray-400">+221 77 262 17 17</span>
              </li>
              <li className="flex items-center">
                <Mail size={20} className="text-primary-500 mr-3 flex-shrink-0" />
                <a href="mailto:contact@amogotech.com" className="text-gray-400 hover:text-primary-500 transition-colors">
                  amogotech@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center md:flex md:justify-between md:items-center">
          <p className="text-gray-500 mb-4 md:mb-0">
            &copy; {currentYear} AMOGOTech. Tous droits réservés.
          </p>
          {/* <div className="flex flex-wrap justify-center md:justify-end space-x-6">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-primary-500 transition-colors">
              Politique de confidentialité
            </Link>
            <Link to="/terms-of-service" className="text-gray-500 hover:text-primary-500 transition-colors">
              Conditions d'utilisation
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
